export default {"src":"/_next/static/media/0x3c499c542cef5e3811e1192ce70d8cc03d5c3359.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};